/* eslint-disable no-nested-ternary */
import React, { createRef, useState, forwardRef, useImperativeHandle } from 'react';

import axios from 'axios';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';

import Preloader from '../Preloader/Preloader';

import LibraryAssets from './LibraryAssets';
import { SnippetTypeConst } from './SnippetTypeConst';

import CreateAssetRequest from '../../middleware/Asset/createAssetRequest';
import CreateVideoContentSnippetRequest from '../../middleware/ContentSnippet/createVideoContentSnippetRequest';
import UpdateContentVideoSnippetReq from '../../middleware/ContentSnippet/updateContentVideoSnippetReq';

const EditableVideoSnippet = forwardRef((props, ref) => {
  const {
    containerId,
    onCancel,
    onUpdate,
    onCreate,
    onAddFile = () => {},
    isSnippetInForm,
    onEditQuesSuccess,
    snippet,
    handleCloseEditMedia = () => {},
  } = props;

  const [file, setFile] = useState(null);
  const [loader, setLoader] = useState(false);
  const [createAsset, setCreateAsset] = useState(false);
  const [createSnippet, setCreateSnippet] = useState(false);
  const [asset, setAsset] = useState(null);
  const [openLib, setOpenLib] = useState(false);
  const [assetFromLib, setAssetFromLib] = useState(false);
  const dropzoneRef = createRef();
  const [preview, setPreview] = useState(null);

  //   if (dropzoneRef.current) {
  //     dropzoneRef.current.open();
  //   }
  // };

  const openLibrary = () => {
    setOpenLib(true);
  };

  const handleFileDrop = (files) => {
    setFile(files[0]);
    setPreview(URL.createObjectURL(files[0]));
  };

  const handleAssetError = () => {
    setCreateAsset(false);
  };

  const handleAssetResponse = (data) => {
    const {
      asset: {
        createAsset: { signedUrl, asset },
      },
    } = data;
    setCreateAsset(false);
    setLoader(true);
    Object.defineProperty(file, 'name', {
      writable: true,
      value: asset.s3Key,
    });

    axios
      .put(signedUrl, file, { headers: {} })
      .then(() => {
        setAsset(asset);
        setLoader(false);
        setCreateSnippet(true);
      })
      .catch(() => {
        setLoader(false);
      });
  };

  const handleSnippetError = () => {
    setCreateSnippet(false);
  };

  const handleSnippetResponse = (id, sort) => {
    onAddFile(preview, 'video');
    // onCreate(id, sort, SnippetTypeConst.VIDEO, containerId, {
    //   asset,
    //   assetId: asset.assetId,
    // });
    if (snippet) {
      onUpdate(id, sort, SnippetTypeConst.VIDEO, containerId, {
        asset,
        assetId: asset.assetId,
      });
    } else {
      onCreate(id, sort, SnippetTypeConst.VIDEO, containerId, {
        asset,
        assetId: asset.assetId,
      });
    }
    setCreateSnippet(false);
    onEditQuesSuccess();
    if (isSnippetInForm) {
      setOpenLib(false);
      setPreview(null);
      setFile(null);
    }
    handleCloseEditMedia();
  };

  const handleSaveButton = () => {
    if (assetFromLib) setCreateSnippet(true);
    else setCreateAsset(true);
  };

  useImperativeHandle(ref, () => ({
    handleSaveButton() {
      // setCreateAsset(true);
      if (assetFromLib) setCreateSnippet(true);
      else setCreateAsset(true);
    },
  }));

  const handleSelectAsset = (ass) => {
    setAsset(ass);
    setAssetFromLib(true);
  };

  return (
    <>
      {file ? (
        <div>
          <p style={{ textAlign: 'center' }}>{file.path} is uploaded</p>
        </div>
      ) : !openLib ? (
        <div>
          <Dropzone ref={dropzoneRef} accept="video/*" noClick noKeyboard onDropAccepted={handleFileDrop}>
            {({ getRootProps, getInputProps, isDragActive }) => (
              <div className="container">
                <div {...getRootProps({ className: 'dropzone' })}>
                  <input {...getInputProps()} />
                  <p>{isDragActive ? 'Drop here' : 'Drop video here or click to upload'}</p>
                  <p>
                    (<strong>Maximum</strong> 1 file)
                  </p>
                </div>
              </div>
            )}
          </Dropzone>
          <div className="mt-3 text-center">
            <button className="button--green" type="button" onClick={openLibrary}>
              Choose from library
            </button>
          </div>
        </div>
      ) : (
        <LibraryAssets goBack={() => setOpenLib(false)} isClicked={handleSelectAsset} type="VIDEO" />
      )}
      {!isSnippetInForm && (
        <div className="text-right">
          <button className="button--black mt-4 mr-3" type="button" onClick={onCancel}>
            Cancel
          </button>
          <button className="mt-4 button--blue" type="submit" onClick={handleSaveButton}>
            Save
          </button>
        </div>
      )}
      {createAsset && (
        <CreateAssetRequest
          contentType={file.type}
          fileName={file.name}
          fileSizeInBytes={file.size}
          type="VIDEO"
          onError={handleAssetError}
          onSuccessResult={handleAssetResponse}
        />
      )}
      {createSnippet && !snippet && (
        <CreateVideoContentSnippetRequest
          assetId={asset.assetId}
          containerId={containerId}
          onError={handleSnippetError}
          onSuccessResult={handleSnippetResponse}
        />
      )}

      {createSnippet && snippet && (
        <UpdateContentVideoSnippetReq
          assetId={asset.assetId}
          snippetId={snippet.id}
          startAt={0}
          onError={handleSnippetError}
          onSuccessResult={handleSnippetResponse}
        />
      )}
      {loader && <Preloader text="Uploading Video. Please wait!" />}
    </>
  );
});

EditableVideoSnippet.propTypes = {
  containerId: PropTypes.number.isRequired,
  handleCloseEditMedia: PropTypes.func,
  isSnippetInForm: PropTypes.bool,
  onAddFile: PropTypes.func,
  onCancel: PropTypes.func,
  onCreate: PropTypes.func,
  onEditQuesSuccess: PropTypes.func,
  onUpdate: PropTypes.func,
  snippet: PropTypes.instanceOf(Object),
};

EditableVideoSnippet.defaultProps = {
  handleCloseEditMedia: () => {},
  isSnippetInForm: false,
  onAddFile: () => {},
  onCancel: () => {},
  onCreate: () => {},
  onEditQuesSuccess: () => {},
  onUpdate: () => {},
  snippet: null,
};

// export default forwardRef(EditableVideoSnippet);
export default EditableVideoSnippet;
